import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Simple client-side pager. page is 0-indexed.
export default function Pagination({ page, setPage, total, pageSize = 10 }) {
  const pages = Math.ceil((total || 0) / pageSize);
  if (pages <= 1) return null;
  const btn = (disabled) => ({
    opacity: disabled ? 0.4 : 1,
    cursor: disabled ? "not-allowed" : "pointer",
    padding: "5px 12px",
  });
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12, marginTop: 16 }}>
      <button className="au-pill au-pill-glass au-pill-sm" style={btn(page <= 0)} disabled={page <= 0}
        onClick={() => setPage((p) => Math.max(0, p - 1))}>
        <ChevronLeft size={14} /> Prev
      </button>
      <span style={{ fontSize: 12, color: "var(--au-muted)", minWidth: 88, textAlign: "center" }}>
        Page {page + 1} of {pages}
      </span>
      <button className="au-pill au-pill-glass au-pill-sm" style={btn(page >= pages - 1)} disabled={page >= pages - 1}
        onClick={() => setPage((p) => Math.min(pages - 1, p + 1))}>
        Next <ChevronRight size={14} />
      </button>
    </div>
  );
}
